<template>
  <loader v-if="loading"
    :label="$t('conflict.searchingTodos')"
  />
  <choose-exclusive-and-unique-wigo
    v-else
    :conflict="conflict"
    @wigoSelected="prefer($event)"
  />
</template>
<script>
import ChooseExclusiveAndUniqueWigo from '@/components/conflictResolution/ChooseExclusiveAndUniqueWigo'
import Loader from '@/components/global/Loader'

import conflictService from '@/services/conflicts.js'

export default ({
  name: 'ChooseExclusiveAndUniqueWigoView',

  components: {
    ChooseExclusiveAndUniqueWigo,
    Loader,
  },

  mixins: [  ],

  data () {
    return {
      loading: false
    }
  },

  props: {
    conflict: {
      type: Object,
      required: true
    }
  },

  computed: {
  },

  methods: {
    prefer(wigo) {
      console.log('prefer', wigo, this.conflict)
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      const scenariosIds = this.conflict.combinedScenarios?.length > 0 ? this.conflict.combinedScenarios : [ this.conflict.scenario.id ]
      conflictService.prefer(projectId, conflictId, {
        resolution: "ChooseExclusiveAndUniqueWigo",
        wigo: wigo.map(option => option.id),
        scenarios: scenariosIds
      })
      .then(response => {
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] });
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },

})
</script>
<style>
</style>